import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { OutrasReceitas } from 'src/app/admihair/api/dto/outras-receitas';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { TipoPagamento } from 'src/app/admihair/api/dto/tipo-pagamento';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { OutrasReceitasService } from 'src/app/admihair/service/outras-receitas.service';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { TipoPagamentoService } from 'src/app/admihair/service/tipo-pagamento.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-outras-receitas-editar',
  templateUrl: './outras-receitas-editar.component.html',
  styleUrls: ['./outras-receitas-editar.component.scss']
})
export class OutrasReceitasEditarComponent implements OnInit {

  permissaoEditar: boolean = false;
  loading: boolean = true;
  id?: number;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  empresaSelecionada?: Empresa;
  outraReceita?: OutrasReceitas;
  tiposPagamento: TipoPagamento[] = [];
  planosContaEmpresa: PlanoContaEmpresa[] = [];
  progressoRequisicao: boolean = false;
  @ViewChild('f') form?: NgForm;

  constructor(private outrasReceitasService: OutrasReceitasService,
    private tipoPagamentoService: TipoPagamentoService,
    private planoContaEmpresaService: PlanoContaEmpresaService,
    private utilStorageService: UtilStorageService,
    private activatedRouter: ActivatedRoute,
    private erroService: ErroService) { }


  ngOnInit(): void {
    this.permissaoEditar = AuthUtil.verificarPermissao('PERM_EDITAR_OUTRAS_RECEITAS');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    if (this.permissaoEditar) {
      this.carregarIdOutraReceita();
      this.buscarPlanosConta();
    }
  }

  atualizar(){
    this.progressoRequisicao = true;
    if(this.outraReceita)
      this.outraReceita.operador = this.utilStorageService.getUser().usuario.id;
    this.outrasReceitasService.atualizar(this.outraReceita, this.id).subscribe({
      next: (data: OutrasReceitas) => {
        this.outraReceita = data;
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  carregarOutraReceita(){
    this.outrasReceitasService.buscarPorId(this.id).subscribe({
      next: (data: OutrasReceitas) => {
        this.outraReceita = data;
        if(this.outraReceita.dataFluxo){
          this.outraReceita.dataFluxo = new Date(this.outraReceita.dataFluxo + 'T00:00');
        }
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    })
  }

  buscarPlanosConta(){
    const codigos: number[] = [6, 9, 54];
    this.planoContaEmpresaService.listarPorEmpresaECodigo(this.empresaSelecionada?.id, codigos).subscribe({
      next: (data: PlanoContaEmpresa[]) => {
        this.planosContaEmpresa = data;
        this.buscarTipos();
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  
  buscarTipos(){
    this.tipoPagamentoService.listarPorEmpresaEOperacaoInterno(this.empresaSelecionada?.id).subscribe({
      next: (data: TipoPagamento[]) => {
        this.tiposPagamento = data;
        this.carregarOutraReceita();
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    }); 
  }

  carregarIdOutraReceita(){
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }
  }

  limparFormulario(){
    this.form?.reset(); 
  }

  ocultarMensagem(){
    if(this.messagemVisivel){
      this.messagemVisivel = false;
    }
  }
}
